import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const CHECK_IF_LOGGED_IN_BEGIN = 'CHECK_IF_LOGGED_IN_BEGIN';
export const CHECK_IF_LOGGED_IN_SUCCESS = 'CHECK_IF_LOGGED_IN_SUCCESS';
export const CHECK_IF_LOGGED_IN_FAILURE = 'CHECK_IF_LOGGED_IN_FAILURE';

export const CHECK_IF_CAN_ACCESS_STATS_BEGIN = 'CHECK_IF_CAN_ACCESS_STATS_BEGIN';
export const CHECK_IF_CAN_ACCESS_STATS_SUCCESS = 'CHECK_IF_CAN_ACCESS_STATS_SUCCESS';
export const CHECK_IF_CAN_ACCESS_STATS_FAILURE = 'CHECK_IF_CAN_ACCESS_STATS_FAILURE';

export const FETCH_USERNAME_SUCCESS = 'FETCH_USERNAME_SUCCESS';

export const checkIfLoggedIn = () =>
    network.actionWrapper(`${config.getAppUrl()}/clients/user/isLoggedIn`, {
      begin: CHECK_IF_LOGGED_IN_BEGIN,
      success: CHECK_IF_LOGGED_IN_SUCCESS,
      failure: CHECK_IF_LOGGED_IN_FAILURE,
    });

export const checkIfCanAccessStats = () =>
    network.actionWrapper(`${config.getAppUrl()}/statisticstool/get-stats/stats-access-rights.json`, {
      begin: CHECK_IF_CAN_ACCESS_STATS_BEGIN,
      success: CHECK_IF_CAN_ACCESS_STATS_SUCCESS,
      failure: CHECK_IF_CAN_ACCESS_STATS_FAILURE,
    });

export const fetchUsername = () =>
  network.actionWrapper(
      `${config.getAppUrl()}/clients/user/info`,
      {
          begin: ACTION_BEGIN,
          success: FETCH_USERNAME_SUCCESS,
          failure: ACTION_FAILURE,
      });
